import { render, staticRenderFns } from "./admissionFormQuestions.vue?vue&type=template&id=5d012738"
import script from "./admissionFormQuestions.vue?vue&type=script&lang=js"
export * from "./admissionFormQuestions.vue?vue&type=script&lang=js"
import style0 from "./admissionFormQuestions.vue?vue&type=style&index=0&id=5d012738&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports